import { render, staticRenderFns } from "./MovimentacoesFichaPage.vue?vue&type=template&id=2d0be04d&"
import script from "./MovimentacoesFichaPage.vue?vue&type=script&lang=js&"
export * from "./MovimentacoesFichaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports